class EnvironmentService {
  get isDevelopment(): boolean {
    return import.meta.env.DEV;
  }

  get isProduction(): boolean {
    return import.meta.env.PROD;
  }
}

const environmentService = new EnvironmentService();
export { environmentService };
